import * as Yup from "yup";

export const setupProfileSchema = (currentStep, role) => {
  return Yup.object().shape({
    ...(currentStep === 1
      ? {
          filePreview: Yup.string().required("Profile image is required."),
          ...(role === "brand"
            ? {
                brandName: Yup.string()
                  .typeError("Brand Name is required.")
                  .required("Brand Name is required."),
                position: Yup.string()
                  .typeError("Position is required.")
                  .required("Position is required."),
                registeredBy: Yup.string()
                  .typeError("Registered By is required.")
                  .required("Registered By is required."),
              }
            : {
                firstName: Yup.string()
                  .typeError("First Name is required.")
                  .required("First Name is required."),
                lastName: Yup.string()
                  .typeError("Last Name is required.")
                  .required("Last Name is required."),
                age: Yup.number()
                  .typeError("Age must be number.")
                  .required("Age is required.")
                  .min(12, "Age must be greater than 12.")
                  .max(100, "Age must be less than 100."),
              }),
          category: Yup.array()
            .typeError("Category should be array.")
            .of(Yup.string().required("Each category should be string."))
            .min(1, "Atleast one category should be selected.")
            .required("Category is required."),
          bio: Yup.string()
            .typeError("Bio is required.")
            .required("Bio is required."),
        }
      : {}),
    ...(currentStep === 2
      ? {
          phoneNo: Yup.string()
            .typeError("Phone Number is required.")
            .required("Phone Number is required.")
            .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits."), // Regex for 10 digits,
          email: Yup.string()
            .email("Email Id should be valid.")
            .typeError("Email ID is required.")
            .required("Email ID is required."),
          state: Yup.string()
            .typeError("State is required.")
            .required("State is required."),
          city: Yup.string()
            .typeError("City is required.")
            .required("City is required."),
          address: Yup.string()
            .typeError("Address is required.")
            .required("Address is required."),
          addressLine2: Yup.string().typeError("Address Line 2 is required."),
          pincode: Yup.string()
            .typeError("Pincode is required.")
            .required("Pincode is required.")
            .matches(/^[0-9]{6}$/, "Pincode must be 6 digits."),
        }
      : currentStep === 3
        ? {
            website: Yup.string()
              .matches(
                /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/,
                "Website should be a valid URL."
              )
              .typeError("Website is required."),
            socialLinks: Yup.object().shape({
              instagram: Yup.string()
                .typeError("Instagram Profile should be a string.")
                .required("Instagram Profile is required.")
                .matches(
                  /^@[A-Za-z0-9._]{1,29}$/,
                  "Instagram Profile should starts with @ and only contains . and _ as special characters."
                ),
              instagramVerified: Yup.boolean()
                .typeError("Instagram Verified Profile should be a boolean.")
                .test(
                  "is-verified",
                  "Instagram profile must be verified, Please click on connect.",
                  function (value) {
                    const { instagram } = this.parent; // Get the Instagram value
                    if (instagram && instagram.trim()?.length > 1) {
                      return value === true; // Must be true if Instagram exists
                    }
                    return true; // If no Instagram, allow any value
                  }
                ),
              youtube: Yup.string().typeError(
                "YouTube Profile should be a string."
              ),
              youtubeVerified: Yup.boolean().typeError(
                "YouTube Verified Profile should be a boolean."
              ),
              facebook: Yup.string().typeError(
                "Facebook Profile should be a string."
              ),
              facebookVerified: Yup.boolean().typeError(
                "Facebook Verified Profile should be a boolean."
              ),
              linkedin: Yup.string().typeError(
                "LinkedIn Profile should be a string."
              ),
              linkedinVerified: Yup.boolean().typeError(
                "LinkedIn Verified Profile should be a boolean."
              ),
              snapchat: Yup.string().typeError(
                "Snapchat Profile should be a string."
              ),
              snapchatVerified: Yup.boolean().typeError(
                "Snapchat Verified Profile should be a boolean."
              ),
              twitch: Yup.string().typeError(
                "Twitch Profile should be a string."
              ),
              twitchVerified: Yup.boolean().typeError(
                "Twitch Verified Profile should be a boolean."
              ),
              twitter: Yup.string().typeError(
                "Twitter Profile should be a string."
              ),
              twitterVerified: Yup.boolean().typeError(
                "Twitter Verified Profile should be a boolean."
              ),
              reddit: Yup.string().typeError(
                "reddit Profile should be a string."
              ),
              redditVerified: Yup.boolean().typeError(
                "Reddit Verified Profile should be a boolean."
              ),
              quora: Yup.string().typeError(
                "Quora Profile should be a string."
              ),
              quoraVerified: Yup.boolean().typeError(
                "Quora Verified Profile should be a boolean."
              ),
            }),
          }
        : {}),
  });
};
